import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Pagination from 'react-paginating';
import queryString from 'query-string';

// Actions
import {
  handleSubmitUrl,
  removeTableItem,
  handleselect,
  handleChecked,
  removeTableItems,
  handleEditDescription,
  handleEditUrl,
  removeClickKeyword,
  reduceClickKeyword,
  changeExpiredTableItem,
  getKeywordStats
} from "../../actions/dashboard";


const formatOs = (os) => {
  if (!os) return 'NA';
  if (/mac\s*os|macos|os\s*x/i.test(os)) return 'macOS';
  return os;
};

export const Statistics = ({
  history,
  location,
  statistics,
  keywordsPages,
  keywordName,
  getKeywordStats,
}) => {

  const [sortName, setSortName] = useState("updated_at");
  const [sortType, setSortType] = useState("DESC");

  const [keyword, setKeyword] = useState("");
  useEffect(() => {
    const queryObj = queryString.parse(location.search)
    const defaultPage = queryObj.page ? queryObj.page : 1
    setKeyword(queryObj.keyword)
    setTimeout(()=>{
      history.replace({
        pathname: '/statistics',
        search: location.search,
      })
      getKeywordStats({page: defaultPage, keyword: queryObj.keyword, columnName: sortName, order: sortType})
    }, 300)
  }, [])

  const changePage = ({page}) => {
    getKeywordStats({page: page, keyword: keyword, columnName: sortName, order: sortType})
    history.push(`/statistics?keyword=${keyword}&page=${page}`)
  }

  const getCurrentPage = () => {
    const queryObj = queryString.parse(location.search)
    return queryObj.page ? queryObj.page : 1
  }

  const getCurrentKeyword = () => {
    const queryObj = queryString.parse(location.search)
    return queryObj.keyword
  }

  const handleSortTable = (columnName) => {
    if(columnName === sortName) {
      switch(sortType) {
        case 'DESC':
          setSortType("ASC")
          return
        case 'ASC':
          setSortName("updated_at")
          setSortType("DESC")
          return
        default:
          return
      }
    } else {
      setSortName(columnName)
      setSortType("DESC")
      return
    }
  }

  useEffect(() => {
    const defaultPage = getCurrentPage();
    const keywordId = getCurrentKeyword();
    getKeywordStats({page: defaultPage, keyword: keywordId, columnName: sortName, order: sortType})
  }, [sortType, sortName]);

  return (
    <Fragment>
      <div className="tbl_header">
        <span className="stats_back_btn" onClick={() => history.goBack()}>&#8592;</span>
        {"Link Statistics "}
        {keywordName && <span className="stats_keyword_name">for [{keywordName}]</span>}
      </div>
      <div className="tbl">
        <div className="row">
          <div className="cell cell_header cell_visits" onClick={() => handleSortTable("created_at")}>
            <div className="header_clickable">Visits
              {sortName === "created_at" && (
                sortType === "DESC" ? (<i className="caret caret-down"></i>) : (<i className="caret caret-up"></i>)
              )}
            </div>
          </div>
          <div className="cell cell_header cell_stats" onClick={() => handleSortTable("country")}>
            <div className="header_clickable">Country
              {sortName === "country" && (
                sortType === "DESC" ? (<i className="caret caret-down"></i>) : (<i className="caret caret-up"></i>)
              )}
            </div>
          </div>
          <div className="cell cell_header cell_stats" onClick={() => handleSortTable("city")}>
            <div className="header_clickable">City
              {sortName === "city" && (
                sortType === "DESC" ? (<i className="caret caret-down"></i>) : (<i className="caret caret-up"></i>)
              )}
            </div>
          </div>
          <div className="cell cell_header cell_stats_ip" onClick={() => handleSortTable("ip")}>
            <div className="header_clickable">IP Address
              {sortName === "ip" && (
                sortType === "DESC" ? (<i className="caret caret-down"></i>) : (<i className="caret caret-up"></i>)
              )}
            </div>
          </div>
          <div className="cell cell_header cell_device" onClick={() => handleSortTable("device")}>
            <div className="header_clickable">Device
              {sortName === "device" && (
                sortType === "DESC" ? (<i className="caret caret-down"></i>) : (<i className="caret caret-up"></i>)
              )}
            </div>
          </div>
          <div className="cell cell_header cell_os_sm" onClick={() => handleSortTable("os")}>
            <div className="header_clickable">OS
              {sortName === "os" && (
                sortType === "DESC" ? (<i className="caret caret-down"></i>) : (<i className="caret caret-up"></i>)
              )}
            </div>
          </div>
          <div className="cell cell_header cell_browser" onClick={() => handleSortTable("browser")}>
            <div className="header_clickable">Browser
              {sortName === "browser" && (
                sortType === "DESC" ? (<i className="caret caret-down"></i>) : (<i className="caret caret-up"></i>)
              )}
            </div>
          </div>
        </div>
        {statistics.map(elem => {
            return (
              <div className={`row ${elem.status}`} key={elem.id}>
                <div className="cell cell_visits">
                  <div className="wrap_link">{elem.created_at ? elem.created_at : 'NA'}</div>
                </div>
                <div className="cell cell_stats">
                  <div className="wrap_link">{elem.country ? elem.country : 'NA'}</div>
                </div>
                <div className="cell cell_stats">
                  <div className="wrap_link">{elem.city ? (elem.subdivision_code ? `${elem.city}, ${elem.subdivision_code}` : elem.city) : 'NA'}</div>
                </div>
                <div className="cell cell_stats_ip">
                  <div className="wrap_link">{elem.ip ? elem.ip : 'NA'}</div>
                </div>
                <div className="cell cell_device">
                  <div className="wrap_keywords">{elem.device ? elem.device : 'NA'}</div>
                </div>
                <div className="cell cell_os_sm">
                  <div className='wrap_link'>{formatOs(elem.os)}</div>
                </div>
                <div className="cell cell_browser">
                  <div className='wrap_link'>{elem.browser ? elem.browser : 'NA'}</div>
                </div>
              </div>
            )
          })
        }
        <div className="pagination">
          {
            keywordsPages &&
            <Pagination
            className="bg-red pagination-container"
            total={keywordsPages.total * 50}
            limit={50}
            pageCount={3}
            currentPage={keywordsPages.current_page}
          >
            {({
              pages,
              currentPage,
              hasNextPage,
              hasPreviousPage,
              previousPage,
              nextPage,
              totalPages,
              getPageItemProps
            }) => (
              <div className="pagination-buttons">
                <button
                  {...getPageItemProps({
                    pageValue: 1,
                    onPageChange: () => {changePage({page: 1})},
                  })}
                >
                  first
                </button>

                {hasPreviousPage && (
                  <button
                    {...getPageItemProps({
                      pageValue: previousPage,
                      onPageChange: () => {changePage({page: previousPage})}
                    })}
                  >
                    {'<'}
                  </button>
                )}

                {pages.map(page => {
                  let activePage = null;
                  if (currentPage === page) {
                    activePage = { backgroundColor: 'white', border:'inset', fontWeight: 'bold' };
                  }
                  return (
                    <button
                      {...getPageItemProps({
                        pageValue: page,
                        key: page,
                        style: activePage,
                        onPageChange: () => {changePage({page: page})}
                      })}
                    >
                      {page}
                    </button>
                  );
                })}

                {hasNextPage && (
                  <button
                    {...getPageItemProps({
                      pageValue: nextPage,
                      onPageChange: () => {changePage({page: nextPage})}
                    })}
                  >
                    {'>'}
                  </button>
                )}

                <button
                  {...getPageItemProps({
                    pageValue: totalPages,
                    onPageChange: () => {changePage({page: totalPages})}
                  })}
                >
                  last
                </button>
              </div>
            )}
          </Pagination>
          }

        </div>
      </div>
    </Fragment>
  );
};

Statistics.propTypes = {
  statistics: PropTypes.array,
  keywordsPages: PropTypes.object,
  keywordName: PropTypes.string,
  getKeywordStats: PropTypes.func,
};

const mapStateToProps = state => ({
  statistics: state.statistic.statistics,
  keywordsPages: state.statistic.pages,
  keywordName: state.statistic.keywordName,
});

const mapDispatchToProps = {
  handleSubmitUrl,
  removeTableItem,
  handleselect,
  removeTableItems,
  handleChecked,
  handleEditDescription,
  handleEditUrl,
  removeClickKeyword,
  reduceClickKeyword,
  changeExpiredTableItem,
  getKeywordStats
};

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);
